import React from 'react';
import { Link } from 'react-router-dom';
import logoImage from 'assets/images/aptistests_logo.png';
import "../../node_modules/bootstrap/dist/js/bootstrap.min.js";
import { LoadingComponent } from 'shared/components';
import { _HomeService } from 'modules/home/HomeService';

// Color palette for test version cards matching the design
const VERSION_COLORS = ['#e3efff', '#e3fae8', '#ffe8f2', '#fff6cd'];
const VERSION_LABEL_COLORS = ['#5c6bc0', '#4caf50', '#e53935', '#ff9800'];

export default class Menu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: null,
            topHead: null,
            testVersions: null,
        };
        this.subscriptions = {};
    }

    componentDidMount() {
        this.setState({ loading: true });
        _HomeService.getTopNav().subscribe(res => {
            const data = res.data || [];
            this.setState({ data, loading: false });
        });

        _HomeService.getTopHead().subscribe(res => {
            this.setState({ topHead: res.data, loading: false });
        });
    }

    renderGioiThieuDropdown(item) {
        const articles = item.children || [];
        const versionArticles = item.versionArticles || [];

        return (
            <div className="mega-menu-dropdown" style={{
                display: 'none',
                position: 'absolute',
                top: '100%',
                left: '0',
                zIndex: 9999,
                background: '#fff',
                boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                borderRadius: '8px',
                minWidth: '700px',
                padding: '0',
                border: '1px solid #eee',
            }}>
                <div style={{ display: 'flex' }}>
                    {/* Left column: Bài viết "Giới thiệu" */}
                    <div style={{
                        flex: '0 0 280px',
                        padding: '16px',
                        borderRight: '1px dashed #ddd',
                    }}>
                        <div style={{
                            fontSize: '11px',
                            fontWeight: '700',
                            color: '#888',
                            letterSpacing: '0.5px',
                            marginBottom: '10px',
                            textTransform: 'uppercase',
                        }}>
                            VỀ APTIS ESOL
                        </div>
                        {articles.map((child, idx) => (
                            <a key={idx} href={child.seo_name} style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                gap: '10px',
                                padding: '8px 0',
                                borderBottom: idx < articles.length - 1 ? '1px solid #f0f0f0' : 'none',
                                textDecoration: 'none',
                                color: 'inherit',
                            }}>
                                {child.image ? (
                                    <img
                                        src={child.image}
                                        alt={child.title}
                                        style={{
                                            width: '44px',
                                            height: '44px',
                                            objectFit: 'cover',
                                            borderRadius: '6px',
                                            flexShrink: 0,
                                            border: '1px solid #eee',
                                        }}
                                    />
                                ) : (
                                    <div style={{
                                        width: '44px',
                                        height: '44px',
                                        borderRadius: '6px',
                                        flexShrink: 0,
                                        background: '#f0f0f0',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}>
                                        <i className="fa fa-file-text-o" style={{ color: '#999', fontSize: '18px' }} />
                                    </div>
                                )}
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ fontWeight: '600', fontSize: '13px', color: '#333', lineHeight: '1.4',
                                        overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
                                        {child.title}
                                    </div>
                                    {child.des && (
                                        <div style={{ fontSize: '11px', color: '#888', marginTop: '2px', lineHeight: '1.4',
                                            overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}
                                            dangerouslySetInnerHTML={{ __html: child.des }}>
                                        </div>
                                    )}
                                </div>
                            </a>
                        ))}
                    </div>

                    {/* Right column: Bài viết "Phiên bản bài thi" (cat 132) */}
                    <div style={{ flex: 1, padding: '16px' }}>
                        <div style={{
                            fontSize: '11px',
                            fontWeight: '700',
                            color: '#888',
                            letterSpacing: '0.5px',
                            marginBottom: '10px',
                            textTransform: 'uppercase',
                        }}>
                            CÁC PHIÊN BẢN BÀI THI APTIS ESOL
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                            {versionArticles.map((va, idx) => (
                                <a key={idx} href={va.seo_name} style={{
                                    display: 'block',
                                    borderRadius: '8px',
                                    background: '#fff',
                                    textDecoration: 'none',
                                    border: `1px solid #eaeaea`,
                                    overflow: 'hidden',
                                }}>
                                    <div style={{
                                        background: VERSION_COLORS[idx % VERSION_COLORS.length],
                                        height: '75px',
                                        width: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        {va.image && (
                                            <img
                                                src={va.image}
                                                alt={va.title}
                                                style={{
                                                    maxHeight: '50px',
                                                    maxWidth: '80%',
                                                    objectFit: 'contain',
                                                    mixBlendMode: 'multiply'
                                                }}
                                            />
                                        )}
                                    </div>
                                    <div style={{ padding: '12px' }}>
                                        <div style={{
                                            fontWeight: '700',
                                            fontSize: '13px',
                                            color: '#222',
                                            marginBottom: '2px',
                                        }}>
                                            {va.title}
                                        </div>
                                        {va.des && (
                                            <div style={{ 
                                                fontSize: '12px', 
                                                color: '#888',
                                                overflow: 'hidden', 
                                                display: '-webkit-box', 
                                                WebkitLineClamp: 2, 
                                                WebkitBoxOrient: 'vertical' 
                                            }}
                                                dangerouslySetInnerHTML={{ __html: va.des }}>
                                            </div>
                                        )}
                                    </div>
                                </a>
                            ))}
                            {versionArticles.length === 0 && (
                                <div style={{ gridColumn: '1/-1', color: '#bbb', fontSize: '12px', textAlign: 'center', padding: '20px 0' }}>
                                    Chưa có bài viết nào
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderDangKyDropdown(item) {
        const children = item.children || [];
        return (
            <div className="mega-menu-dropdown" style={{
                display: 'none',
                position: 'absolute',
                top: '100%',
                right: '0',
                left: 'auto',
                zIndex: 9999,
                background: '#fff',
                boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                borderRadius: '8px',
                minWidth: '420px',
                padding: '16px',
                border: '1px solid #eee',
            }}>
                <div style={{
                    fontSize: '11px',
                    fontWeight: '700',
                    color: '#888',
                    letterSpacing: '0.5px',
                    marginBottom: '12px',
                    textTransform: 'uppercase',
                }}>
                    LỰA CHỌN PHIÊN BẢN BÀI THI
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                    {children.map((child, idx) => (
                        <a key={idx} href={`/dang-ky-thong-tin?version_id=${child.id}`} style={{
                            display: 'block',
                            padding: '14px',
                            borderRadius: '8px',
                            background: VERSION_COLORS[idx % VERSION_COLORS.length],
                            textDecoration: 'none',
                            border: `1px solid ${VERSION_LABEL_COLORS[idx % VERSION_LABEL_COLORS.length]}30`,
                        }}>
                            <div style={{
                                fontWeight: '700',
                                fontSize: '13px',
                                color: '#222',
                                marginBottom: '4px',
                            }}>
                                {child.title}
                            </div>
                            {child.short_des && (
                                <div style={{
                                    fontSize: '11px',
                                    color: '#555',
                                    marginBottom: '4px',
                                    lineHeight: '1.4',
                                }}>
                                    {child.short_des}
                                </div>
                            )}
                            {child.fee && (
                                <div style={{
                                    fontSize: '11px',
                                    color: VERSION_LABEL_COLORS[idx % VERSION_LABEL_COLORS.length],
                                    fontWeight: '600',
                                    marginTop: '4px',
                                }}>
                                    {new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(child.fee)}
                                </div>
                            )}
                        </a>
                    ))}
                </div>
            </div>
        );
    }

    render() {
        let { data, topHead } = this.state;

        // Sort: put "Đăng ký thi" (id=129) last
        const sortedData = data ? [...data].sort((a, b) => {
            if (String(a.id) === '129') return 1;
            if (String(b.id) === '129') return -1;
            return 0;
        }) : [];

        return (
            <div id="menu">
                <LoadingComponent loading={this.state.loading}></LoadingComponent>
                <style>{`
                    .mega-nav-item { position: relative; }
                    .mega-nav-item:hover .mega-menu-dropdown { display: block !important; }
                    .mega-nav-item .nav-link { cursor: pointer; }
                    .mega-menu-dropdown a:hover { opacity: 0.85; }
                `}</style>
                <div className="container">
                    <nav className="navbar navbar-expand-lg navbar-light">
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon" />
                        </button>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav text-uppercase font-14">
                                <li className="nav-item active">
                                    <a className="nav-link main-color" href="/"><i className="fa fa-home" /></a>
                                </li>
                                {sortedData.map((item, index) => {
                                    const hasChildren = item.children && item.children.length > 0;
                                    const isGioiThieu = String(item.id) === '111';
                                    const isDangKy = String(item.id) === '129';

                                    if (isGioiThieu) {
                                        return (
                                            <li key={index} className="nav-item mega-nav-item">
                                                <a className="nav-link main-color dropdown-toggle" href={item.seo_name}>
                                                    {item.title}
                                                </a>
                                                {this.renderGioiThieuDropdown(item)}
                                            </li>
                                        );
                                    }

                                    if (isDangKy) {
                                        return (
                                            <li key={index} className="nav-item mega-nav-item d-flex align-items-center ml-lg-2">
                                                <a
                                                    href="javascript:void(0);"
                                                    style={{ 
                                                        background: '#e3000f', 
                                                        color: '#fff', 
                                                        padding: '8px 20px', 
                                                        borderRadius: '30px', 
                                                        fontWeight: '700',
                                                        fontSize: '14px',
                                                        textTransform: 'uppercase',
                                                        textDecoration: 'none',
                                                        display: 'inline-block',
                                                        boxShadow: '0 2px 4px rgba(227, 0, 15, 0.3)'
                                                    }}
                                                >
                                                    {item.title}
                                                </a>
                                                {hasChildren && this.renderDangKyDropdown(item)}
                                            </li>
                                        );
                                    }

                                    return (
                                        <li key={index} className={`nav-item ${hasChildren ? 'dropdown custom-dropdown' : ''}`}>
                                            <a
                                                className={`nav-link main-color ${hasChildren ? 'dropdown-toggle' : ''}`}
                                                href={item.seo_name}
                                            >
                                                {item.title}
                                            </a>
                                            {hasChildren && (
                                                <div className="dropdown-menu">
                                                    {item.children.map((child, idx) => (
                                                        <a key={idx} className="dropdown-item d-flex align-items-center" href={child.seo_name}>
                                                            {child.image && <img src={child.image} alt={child.title} style={{ width: '36px', height: '36px', objectFit: 'cover', marginRight: '10px', borderRadius: '4px' }} />}
                                                            <div>
                                                                <div style={{ fontWeight: 'bold', fontSize: '13px' }}>{child.title}</div>
                                                                {child.des && <div style={{ fontSize: '11px', color: '#666' }} dangerouslySetInnerHTML={{ __html: child.des }}></div>}
                                                            </div>
                                                        </a>
                                                    ))}
                                                </div>
                                            )}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
        );
    }
}
